import React, { Suspense, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import channelsUtil from '../../../helpers/channelsUtil';
import { playerTypes } from '@libs/constants';
import { GenericBitmovinPlayer } from '../../../features';

import Header from '../VodPlayer/Header';
export interface ProgramData {
    title: string;
    channelTitle: string;
    startTime: string;
    endTime: string;
    tuningURLs: {
        catchUpURL: string;
    };
    poster?: string;
    playbackTimestamp?: number;
}

export type HandleError = (error: { title: string; description: string }) => void;

export const CatchupPlayer: React.FC = () => {
    const location = useLocation();
    const [catchupUrl, setCatchupUrl] = useState<string | null>(null);
    const selectedPRef = useRef<ProgramData | null>(null);
    const programDataRef = useRef<ProgramData | null>(null);
    const navigate = useNavigate();

    // Initialize program data and set catch-up URL from router state
    useEffect(() => {
        const programData = location.state?.programData as ProgramData;
        if (!programData?.tuningURLs?.catchUpURL) {
            return;
        }
        programDataRef.current = programData;
        selectedPRef.current = programData;
        // Set the catch-up URL with proper time parameters
        const formattedUrl = channelsUtil.appendStartEndTime(
            programData.tuningURLs.catchUpURL,
            Number(programData.startTime),
            Number(programData.endTime)
        );
        setCatchupUrl(formattedUrl);
    }, [location]);

    const closePlayer = () => {
        navigate(-1);
    };

    return (
        <Suspense fallback={null}>
            <GenericBitmovinPlayer
                streamingUrl={catchupUrl}
                LinearAsset={location.state.programData}
                playerType={playerTypes.Catchup}
                header={<Header closePlayer={closePlayer} />}
            />
        </Suspense>
    );
};
